import styled from "styled-components";

export const ContentWrapper = styled.div`
  margin-top: 0;
  margin-bottom: 20vh;
  padding: 20px 0 20px 20px;
  @media (min-width: 900px) {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
  }
`;

export const ContentBloc = styled.div`
  @media screen and (min-width: 900px){
    margin-right: 20px;
    width: 50%;
  }
`;

export const TextLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: inherit;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 4px;
  text-decoration-color: currentColor;
  transition: color 0.15s ease, text-decoration-color 0.15s ease;
  &[href^="mailto:"] {
    text-decoration: none;
  }
  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
  &:hover,
  &:focus-visible {
    color: #E49806;
    text-decoration-color: #E49806;
    outline: none;
  }
`;
